import { render, staticRenderFns } from "./add-usuario-prime-sidebar.vue?vue&type=template&id=ebf648be&scoped=true&"
import script from "./add-usuario-prime-sidebar.vue?vue&type=script&lang=js&"
export * from "./add-usuario-prime-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf648be",
  null
  
)

export default component.exports